/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useProjectUrl } from 'domain/shared/project';

interface EditProjectButtonProps extends EditButtonProps {}

const EditProjectButton = (props: EditProjectButtonProps) => {
  const { getUpdateEntityUrl } = useProjectUrl();

  return <EditButton path={id => getUpdateEntityUrl(id)} {...props} />;
};

export default EditProjectButton;
